const dataFormatClass = (value: string | null | undefined) => {
  if (value === "2") { return "badge-dark"; }
  else if (value === "3") { return "badge-info"; }
  else if (value === "8") { return "badge-secondary"; }
  else if (value === "10") { return "badge-success"; }
  else if (value === "11") { return "badge-danger"; }
  else if (value === "12") { return "badge-warning"; }
  else { return "badge-success"; }
}

const formattedNumber = (value: number | null | undefined) => {
  return value?.toLocaleString();
}
export default function useCommonUtils(){
  return{
    dataFormatClass,
    formattedNumber
  }
}
